import React, { Component } from 'react';

class UserRow extends Component {


  constructor(props) {
      super(props);
      this.state = {

      }
    }

  renderEditButton = () => {
    return (
      <button
        type="button"
        className="btn btn-light"
        onClick={this.props.editUser}
      >
        {"Edit"}
      </button>
    )
  }

  renderGroupList = () => {
    let groups = this.props.groups;
    if (groups === undefined || groups === null || groups.length === 0) {
      return "None";
    }

    let groupString = groups[0];
    if (groups.length > 1) {
      groupString = `${groupString} + ${groups.length - 1} more`;
    }

    return groupString;
  }

  renderVerified(){
    let icon = this.props.verified ? "ok" : "remove"
    return (
      <div className="verifiedIconBackground">
        <span className={`glyphicon glyphicon-${icon}`}></span>
      </div>
    );
  }

  render() {
    return (
      <tr className={this.props.enabled ? "rowEnabled" : "rowDisabled"}>
        <td className="userRow">
          <div className = "pictureIconBackground">
            <span className="glyphicon glyphicon-user tableIcon"></span>
          </div>
        </td>
        <td className="userRow">{this.props.uid}</td>
        <td className="userRow">{this.props.cn}</td>
        <td className="userRow">{this.props.sn}</td>
        <td className="userRow">{this.renderGroupList()}</td>
        <td className="userRow">{this.renderVerified()}</td>
        <td className="userRow">{this.renderEditButton()}</td>
      </tr>
    );
  }
}

export default UserRow;


// WEBPACK FOOTER //
// ./src/Components/userManagement/UserRow.js